import { exists } from '@zapier/common-utils';

export default function goto(url) {
  return exists(window) ? (window.location.href = url) : void 0;
}
